/**
 * PretreatWarning (BLU-1509): the loud amber "Needs pretreat" panel for a
 * shirt switched DTF to DTG (Brett 2026-10-26: allowed, with a loud warning).
 * The caller plays its one buzz, the audio twin (PRODUCTION_DESIGN §5.2).
 */
import type { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { Droplets } from 'lucide-react';
import { cn } from '@/lib/utils';

export function PretreatWarning({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  const { t } = useTranslation('production');
  return (
    <div
      {...props}
      className={cn(
        'flex items-start gap-3 rounded-lg border-2 border-amber-500 bg-amber-100 p-4 text-amber-950 dark:border-amber-500 dark:bg-amber-950/50 dark:text-amber-50',
        className,
      )}
    >
      <Droplets className="mt-0.5 h-7 w-7 shrink-0 text-amber-700 dark:text-amber-300" aria-hidden="true" />
      <div className="min-w-0 space-y-1">
        <p className="text-xl font-bold">{t('scanRouting.switch.pretreatTitle')}</p>
        <p className="text-base sm:text-lg">{t('scanRouting.switch.pretreatBody')}</p>
      </div>
    </div>
  );
}
